import { scrollWithOffset } from "./helpers";
import { setupPersonCards } from "./peoplecard";
import { toggleInit } from "@jco-digital/jutils/lib";

function handleAnchorClick(e) {
  const target = e.target;
  if (!target || !target.href) return;

  if (window.location.href === target.href.split("#")[0]) e.preventDefault();

  document
    .querySelectorAll('a[href^="/#"]')
    .forEach((el) => el.classList.remove("active-anchor"));
  target.classList.add("active-anchor");

  const link = `#${
    target.href.split("#").length > 1 ? target.href.split("#")[1] : ""
  }`;

  if (link === "#") return;

  const targetEl = document.querySelector(link);
  if (targetEl) scrollWithOffset(targetEl);
}

function setupAnchors() {
  const anchors = document.querySelectorAll('a[href^="/#"]');
  anchors.forEach((anchor) =>
    anchor.addEventListener("click", handleAnchorClick)
  );
}

window.addEventListener("DOMContentLoaded", function () {
  setupAnchors();
  setupPersonCards();
  toggleInit();
});
